import { createContext} from "react";
const ThemeContext = createContext();
ThemeContext.displayName = "ThemeContext";
export default ThemeContext;